import BaseEvent from './BaseEvent.js';

class IgnoreEvent extends BaseEvent {
  handle() {
    // do nothing.
  }
}

export default IgnoreEvent;
